export default __webpack_public_path__ + "static/media/gallery_12.8bf0d709.jpg";